// === 1. SUPPRESSION DES MARGES SI AUCUN SPONSOR ===
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.sponsor-wrapper');
  if (!wrapper || !wrapper.querySelector('.sponsor-item')) {
    document.body.style.paddingTop = '0';
    document.body.style.paddingLeft = '0';
  }
});

// === 2. MENU MOBILE AVEC OVERLAY ===
const toggle = document.getElementById('menu-toggle');
const menu = document.getElementById('menu-mobile');
const overlay = document.getElementById('nav-overlay');

if (toggle && menu && overlay) {
  const toggleMenu = () => {
    const isActive = menu.classList.toggle('active');
    toggle.classList.toggle('open');
    overlay.classList.toggle('active');
    toggle.setAttribute('aria-expanded', String(isActive));
    menu.setAttribute('aria-hidden', String(!isActive));
    document.body.style.overflow = isActive ? 'hidden' : '';
  };

  toggle.addEventListener('click', toggleMenu);
  overlay.addEventListener('click', toggleMenu);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('active')) {
      toggleMenu();
      toggle.focus();
    }
  });
}

// === 3. GESTION DU SLIDESHOW ===
import { initSlideshows } from './slideshow.js';

// Initialiser quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  // Import dynamique uniquement si nécessaire
  if (document.querySelector('.slideshow-wrapper')) {
    import('./slideshow.js').then(module => {
      module.initSlideshows();
    });
  }
});